<script setup>
import { computed } from 'vue';

const props = defineProps({
  label: {
    type: Object,
    required: true,
  },
  /** Tighter padding for tables and dense rows */
  dense: {
    type: Boolean,
    default: false,
  },
  /** Conversation suggestions and similar */
  dashedOutline: {
    type: Boolean,
    default: false,
  },
});

const color = computed(() => props.label?.color || '#64748b');

const shellClass = computed(() =>
  [
    'inline-flex max-w-full min-w-0 items-center gap-1.5 rounded-lg font-semibold outline outline-1 -outline-offset-1 text-n-slate-12',
    props.dense ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-0.5 text-sm',
    props.dashedOutline ? 'outline-dashed' : '',
  ]
    .filter(Boolean)
    .join(' ')
);

const shellStyle = computed(() => ({
  backgroundColor: `${color.value}26`,
  outlineColor: color.value,
}));
</script>

<template>
  <span :class="shellClass" :style="shellStyle">
    <span
      v-if="label.emoji"
      class="shrink-0 text-base leading-none"
      aria-hidden="true"
    >
      {{ label.emoji }}
    </span>
    <span class="min-w-0 truncate">
      {{ label.title }}
    </span>
  </span>
</template>
